import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import PageHeader from '../../shared/page-header/PageHeader'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import { getStorageValues } from '../../shared/CommonFunctions'
import { getApiBaseUrl } from '../../utils/apiConfig'
import LoanApplicatgionFromGrid from './LoanApplicatgionFromGrid'
import { logAuditEvent } from '../../utils/auditLogger'

function LoanApplicatgionFromMain(props) {
  const [rows, setRows] = useState([])
  const [alert, setAlert] = useState(null)
  const [loading, setLoading] = useState(false)
  const moduleName = props.Module || 'Loan Application Form'

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`)
  }, [moduleName])

  const fetchFinanceRegisters = async () => {
    setLoading(true)
    try {
      const response = await axios.get(getApiBaseUrl() + '/financeregister/getall', {
        params: { UserId: getStorageValues('userId') }
      })
      if (response.status === 200) {
        setRows(response.data.data || [])
      }
    } catch (error) {
      console.error(error)
      CreateAlert('Unable to load loan application list', 'Error', setAlert)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFinanceRegisters()
  }, [])

  const pendingRows = useMemo(() => {
    const norm = (status) => (status || '').toString().toLowerCase().trim()
    const isCompleted = (status) => {
      const s = norm(status)
      return s === 'completed' || s === 'complete'
    }
    const isCancelled = (status) => {
      const s = norm(status)
      return s === 'cancelled' || s === 'canceled' || s === 'cancel'
    }
    return (rows || []).filter((r) => !isCompleted(r.Status) && !isCancelled(r.Status))
  }, [rows])

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayText={''}
        displayModule={props.Module}
        onRefresh={fetchFinanceRegisters}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={true}
        showAddButton={false}
      />
      <LoanApplicatgionFromGrid
        rows={pendingRows}
        isLoading={loading}
        onRefresh={fetchFinanceRegisters}
        moduleName={moduleName}
      />
    </>
  )
}

export default LoanApplicatgionFromMain
